import * as React from 'react';

import { IBreadcrumb } from '../../types/newbuilding';
import { isArrayWithItems } from '../../utils/functional';

import * as styles from './Breadcrumbs.css';

export interface IBreadcrumbsProps {
  breadcrumbs: IBreadcrumb[];
}

export const Breadcrumbs: React.FC<IBreadcrumbsProps> = ({ breadcrumbs }) => {
  if (!isArrayWithItems(breadcrumbs)) {
    return null;
  }

  return (
    <ul className={styles['container']}>
      {breadcrumbs.map(({ title, url }) => (
        <li key={url} className={styles['item']}>
          <a className={styles['link']} href={url}>
            {title}
          </a>
        </li>
      ))}
    </ul>
  );
};
